import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MuiLink from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { Tooltip, Typography } from '@material-ui/core';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ConfirmationDialog from 'Components/UI/ConfirmationDialog';

const styles = theme => ({
  root: {
    display: 'flex',
    cursor: 'pointer',
    backgroundColor: theme.palette.common.white,
    alignItems: 'center',
    marginBottom: theme.spacing(0.5),
    boxShadow: '0px 3px 15px #0000000B',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '&:hover': {
      textDecoration: 'none',
      color: 'inherit',
    },
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemAccent: {
    width: '5px',
    height: '30px',
    margin: '3px 8px 3px 3px',
    backgroundColor: theme.palette.facet.accentBlue,
  },
  itemText: {
    color: theme.palette.facet.primaryGray,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  reminderButton: {
    padding: theme.spacing(0, 1),
  },
  feedback: {
    display: 'flex',
    marginLeft: theme.spacing(0.5),
  },
  feedbackButton: {
    padding: theme.spacing(0.5),
  },
  complete: {
    color: theme.palette.facet.accentGreen,
  },
  cancel: {
    color: theme.palette.facet.red,
  },
});

const ReminderItem = ({
  className,
  classes,
  title,
  onMarkAccurate,
  href,
}) => {
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [markedAccurate, setMarkedAccurate] = useState(false);

  const handleReminderButtonClick = (e, accurate) => {
    e.preventDefault();
    e.stopPropagation();
    setMarkedAccurate(accurate);
    setConfirmationModalOpen(true);
  };

  return (
    <>
      <MuiLink
        role="presentation"
        href={href}
        className={classNames(classes.root, className)}
      >
        <div className={classes.itemContainer}>
          <div className={classes.itemAccent} />
          <Typography variant="h6" className={classes.itemText}>{title}</Typography>
        </div>
        <div className={classes.feedback}>
          <Tooltip title="Mark as Completed" placement="top" arrow>
            <IconButton
              className={classNames(classes.complete, classes.feedbackButton)}
              onClick={e => handleReminderButtonClick(e, true)}
            >
              <CheckIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Inaccurate Reminder" placement="top" arrow>
            <IconButton
              className={classNames(classes.cancel, classes.feedbackButton)}
              onClick={e => handleReminderButtonClick(e, false)}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      </MuiLink>
      {confirmationModalOpen && (
        <ConfirmationDialog
          onCancel={() => {
            setConfirmationModalOpen(false);
          }}
          title={`Are you sure you to want mark this reminder as ${markedAccurate ? 'accurate' : 'inaccurate'}?`}
          message={title}
          onConfirm={() => {
            setConfirmationModalOpen(false);
            onMarkAccurate(markedAccurate);
          }}
          showCloseIcon={false}
        />
      )}
    </>
  );
};

ReminderItem.defaultProps = {
  className: '',
  href: null,
};

ReminderItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onMarkAccurate: PropTypes.func.isRequired,
  href: PropTypes.string,
};

export default withStyles(styles)(ReminderItem);
